import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { ActionValidIcon } from '@hm-group/fabric-icons/icons/ActionValidIcon';
import { CloseIcon } from '@hm-group/fabric-icons/icons/CloseIcon';
import { ErrorIcon } from '@hm-group/fabric-icons/icons/ErrorIcon';
import { InfoIcon } from '@hm-group/fabric-icons/icons/InfoIcon';
import { WarningIcon } from '@hm-group/fabric-icons/icons/WarningIcon';
import cn from 'classnames';
import IconButton from "../../Buttons/IconButton";
import BodyText from "../../Typography/texts/BodyText";
import "./BannerNotification.css";
var styles = { "animationContainer": "ac579c", "animationContainerInner": "e8ba5e", "banner": "e21af5", "banner_success": "cdb7db", "banner_info": "e1b625", "banner_warning": "d16620", "banner_error": "dc2065", "message": "d1ca3e", "buttonClose": "a769e8" };
const BannerNotification = forwardRef(({ closeLabel, message, severity = 'warning', testId, shouldHideCloseButton = false }, ref) => {
    const containerRef = useRef(null);
    const childrenRef = useRef(null);
    const [visible, setVisible] = useState(true);
    useImperativeHandle(ref, () => containerRef.current);
    const handleAnimationEnd = () => {
        setVisible(false);
    };
    const handleDismiss = () => {
        setVisible(false);
    };
    useEffect(() => {
        if (!containerRef.current) {
            return;
        }
        if (visible) {
            containerRef.current.style.display = 'block';
            containerRef.current.style.height = 'auto';
            containerRef.current.style.opacity = '1';
        }
        else {
            containerRef.current.style.display = 'none';
            containerRef.current.style.height = '0px';
            containerRef.current.style.opacity = '0';
        }
    }, [visible]);
    useEffect(() => {
        const applyNewStyles = () => {
            var _a;
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
        };
        if (!childrenRef.current || !containerRef.current) {
            return () => { };
        }
        const { height } = containerRef.current.style;
        const isAlreadyProcessed = (visible && height === 'auto') || (!visible && height === '0px');
        if (isAlreadyProcessed) {
            return () => { };
        }
        let timeoutId;
        const transitionDuration = 300;
        if (visible) {
            containerRef.current.style.display = 'block';
            containerRef.current.style.opacity = '1';
            applyNewStyles();
            containerRef.current.style.height = window.getComputedStyle(childrenRef.current).height;
            timeoutId = window.setTimeout(() => {
                if (!containerRef.current) {
                    return;
                }
                handleAnimationEnd();
                containerRef.current.style.height = 'auto';
            }, transitionDuration);
        }
        if (!visible) {
            containerRef.current.style.opacity = '0';
            containerRef.current.style.height = window.getComputedStyle(childrenRef.current).height;
            applyNewStyles();
            containerRef.current.style.height = '0px';
            timeoutId = window.setTimeout(() => {
                if (!containerRef.current) {
                    return;
                }
                handleAnimationEnd();
                containerRef.current.style.display = 'none';
            }, transitionDuration);
        }
        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [visible]);
    let iconComponent;
    switch (severity) {
        case 'error':
            iconComponent = React.createElement(ErrorIcon, { "data-testid": "error-icon" });
            break;
        case 'warning':
            iconComponent = React.createElement(WarningIcon, { "data-testid": "warning-icon" });
            break;
        case 'info':
            iconComponent = React.createElement(InfoIcon, { "data-testid": "info-icon" });
            break;
        default:
            iconComponent = React.createElement(ActionValidIcon, { "data-testid": "action-valid-icon" });
            break;
    }
    return (React.createElement("div", { ref: containerRef, "aria-live": "assertive", role: "alertdialog", "aria-hidden": !visible, hidden: !visible, className: styles.animationContainer, "data-testid": testId },
        React.createElement("div", { ref: childrenRef, className: styles.animationContainerInner },
            React.createElement("div", { className: cn(styles.banner, styles[`banner_${severity}`]) },
                iconComponent,
                React.createElement(BodyText, { className: styles.message }, message),
                !shouldHideCloseButton && (React.createElement(IconButton, { className: styles.buttonClose, variant: "ghost", iconElement: React.createElement(CloseIcon, null), onClick: handleDismiss }, closeLabel))))));
});
export default BannerNotification;
//# sourceMappingURL=BannerNotification.js.map